import { render, staticRenderFns } from "./AccAdmin.vue?vue&type=template&id=11ecc314"
import script from "./AccAdmin.vue?vue&type=script&lang=js"
export * from "./AccAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports